import * as swcHelpers from '@swc/helpers';
import 'react';
import { useBrPageContext } from '../context/context.js';
import '@bloomreach/react-sdk';
import '../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import { getBrPageContent } from '../utils/get-br-page-content.js';
import '@grandvisionhq/utils';
import '@grandvisionhq/common';
import '../utils/http-client.js';
import { useBloomreachPageModels } from './use-bloomreach-page-models.js';
import { useSubscribeNewsletter } from './use-subscribe-newsletter.js';

const useBloomreachNewsletterV2Data = ()=>{
    var ref;
    const newsletterSubscribe = useSubscribeNewsletter();
    /**
   * Get the newsletter v2 content from the BR Newsletter content model
   */ const page = useBrPageContext();
    const pageModels = useBloomreachPageModels();
    const newsletterContent = getBrPageContent(page, pageModels === null || pageModels === void 0 ? void 0 : pageModels.newsletterV2Configuration);
    if (!newsletterContent) {
        return undefined;
    }
    const successHeader = newsletterContent === null || newsletterContent === void 0 ? void 0 : newsletterContent.successHeader;
    const signupHeader = newsletterContent === null || newsletterContent === void 0 ? void 0 : newsletterContent.signupHeader;
    const backgroundColor = newsletterContent === null || newsletterContent === void 0 ? void 0 : newsletterContent.backgroundColor;
    const consent = newsletterContent === null || newsletterContent === void 0 ? void 0 : (ref = newsletterContent.consent) === null || ref === void 0 ? void 0 : ref.value;
    return swcHelpers.objectSpread({}, newsletterSubscribe, {
        backgroundColor,
        consent,
        signupHeader,
        successHeader
    });
};

export { useBloomreachNewsletterV2Data };
//# sourceMappingURL=use-bloomreach-newsletter-v2-data.js.map
